import { computed } from 'vue'
import { splitFirstSentence, splitByFirstBoldBlock, transformMarkedText } from './splitSentence'

export function useParsedStWeText(rawStWeData) {
  //'**한편' 기준으로 강점/약점 분리
  const rawStWe = computed(() => {
    const [strengthPart, weaknessPart] = rawStWeData.value.split('**한편')
    const strength = strengthPart?.trim() || ''
    const weakness = weaknessPart ? `**한편${weaknessPart.trim()}` : ''
    return { strength, weakness }
  })

  const strengthParsed = computed(() => splitFirstSentence(rawStWe.value.strength))
  const weaknessParsed = computed(() => splitByFirstBoldBlock(rawStWe.value.weakness))
  // 첫 문장과 나머지 문장 분리
  const strengthMainText = computed(() => strengthParsed.value.first)
  const strengthDetailText = computed(() => strengthParsed.value.restSentences.join(' '))
  const weaknessMainText = computed(() => weaknessParsed.value.first)
  const weaknessDetailText = computed(() => weaknessParsed.value.restSentences.join(' '))
  // 스타일 적용 html
  const parsedStrengthMain = computed(() => transformMarkedText(strengthMainText.value))
  const parsedStrengthDetail = computed(() => transformMarkedText(strengthDetailText.value))
  const parsedWeaknessMain = computed(() => transformMarkedText(weaknessMainText.value))
  const parsedWeaknessDetail = computed(() => transformMarkedText(weaknessDetailText.value))

  return {
    parsedStrengthMain,
    parsedStrengthDetail,
    parsedWeaknessMain,
    parsedWeaknessDetail,
  }
}
